// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".first-account-id[data-v-e1732afc]{cursor:pointer;padding-right:10px}", ""]);
// Exports
module.exports = exports;
